module.exports = __webpack_public_path__ + "img/pop_custom1.de5dcf21.jpg";